import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { CheckCircle2Icon, ShoppingBagIcon, XIcon } from 'lucide-react';
import { recentPurchases } from '../data/purchases';
const FIRST_DELAY = 8000;
const VISIBLE_FOR = 5000;
const MIN_GAP = 15000;
const MAX_GAP = 30000;
function randomGap() {
  return MIN_GAP + Math.random() * (MAX_GAP - MIN_GAP);
}
export function PurchaseNotifications() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const reduceMotion = useReducedMotion();
  useEffect(() => {
    if (dismissed) return;
    const timer = window.setTimeout(() => {
      if (visible) {
        setVisible(false);
        setIndex(i => (i + 1) % recentPurchases.length);
      } else {
        setVisible(true);
      }
    }, visible ? VISIBLE_FOR : index === 0 ? FIRST_DELAY : randomGap());
    return () => window.clearTimeout(timer);
  }, [visible, index, dismissed]);
  const purchase = recentPurchases[index];
  return <div className="pointer-events-none fixed bottom-4 left-4 right-4 z-50 sm:right-auto" aria-live="polite" data-id="element-42" data-mp="otv4ercy77g7">
      <AnimatePresence data-id="element-43" data-mp="jtyyunolr7yj">
        {visible && !dismissed && <motion.div key={purchase.name} initial={reduceMotion ? {
        opacity: 0
      } : {
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={reduceMotion ? {
        opacity: 0
      } : {
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative flex w-full items-center gap-3 rounded-2xl border border-line bg-surface p-3 pr-9 shadow-xl shadow-black/50 sm:w-[340px]" data-id="element-44" data-mp="jurw8y1o8l40">
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-success/15" data-id="element-45" data-mp="3ncjwt0tviddt">
              <ShoppingBagIcon className="h-6 w-6 text-success" aria-hidden="true" data-id="element-46" data-mp="3jbq8w7gfkykx" />
            </span>
            <div className="min-w-0" data-id="element-47" data-mp="3kopwznccdofd">
              <p className="truncate text-sm font-bold text-heading" data-id="element-48" data-mp="3pqf9l7f7qa5k">
                {purchase.name} <span className="font-medium text-body" data-id="element-49" data-mp="3asva2g13576s">de {purchase.city}</span>
              </p>
              <p className="truncate text-sm text-body" data-id="element-50" data-mp="3frfzdkesu6gg">
                compró <span className="font-bold text-heading" data-id="element-51" data-mp="3fpv8c4rp15nc">{purchase.product}</span>
              </p>
              <p className="mt-0.5 flex items-center gap-1 text-xs text-body" data-id="element-52" data-mp="31z01sz4o30mx">
                <CheckCircle2Icon className="h-3.5 w-3.5 text-success" aria-hidden="true" data-id="element-53" data-mp="36rt6xo41sazj" />
                Compra verificada · {purchase.time}
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Cerrar avisos de compra" className="absolute right-2 top-2 rounded-full p-1 text-body transition-colors duration-150 ease-out hover:bg-ink hover:text-heading focus:outline-none focus-visible:ring-2 focus-visible:ring-success" data-id="element-54" data-mp="2x0f0ewdoiaww">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-55" data-mp="24frwaguwrfo7" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}